import katex from "katex";
import { useMemo } from "react";
import { cn } from "@volca/ui/lib/utils";
import "katex/dist/katex.min.css";
import "./chat-math.css";

interface MathEquationProps {
  source: string;
  complete: boolean;
}

export const MathEquation = ({ source, complete }: MathEquationProps) => {
  const displayMode = source.startsWith("\\[");
  const html = useMemo(() => {
    if (!complete) return null;
    try {
      return katex.renderToString(source.slice(2, -2).trim(), {
        displayMode,
        throwOnError: true,
        strict: "error",
        trust: false,
        maxSize: 20,
        maxExpand: 1000,
      });
    } catch {
      return null;
    }
  }, [source, complete, displayMode]);

  const className = cn("chat-math", {
    "chat-math-display": displayMode,
    "whitespace-pre-wrap": html === null,
  });
  return html === null ? (
    <span className={className}>{source}</span>
  ) : (
    <span className={className} dangerouslySetInnerHTML={{ __html: html }} />
  );
};
